import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import GGEditorContext from "./";
export default function (WrappedComponent) {
  var InjectGGEditorContext =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(InjectGGEditorContext, _React$Component);

    function InjectGGEditorContext() {
      _classCallCheck(this, InjectGGEditorContext);

      return _possibleConstructorReturn(this, _getPrototypeOf(InjectGGEditorContext).apply(this, arguments));
    }

    _createClass(InjectGGEditorContext, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = _objectWithoutProperties(_this$props, ["forwardRef"]);

        return React.createElement(GGEditorContext.Consumer, null, function (context) {
          return React.createElement(WrappedComponent, _extends({
            ref: forwardRef
          }, rest, context));
        });
      }
    }]);

    return InjectGGEditorContext;
  }(React.Component);

  return React.forwardRef(function (props, ref) {
    return React.createElement(InjectGGEditorContext, _extends({}, props, {
      forwardRef: ref
    }));
  });
}